import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}cost-centers`, { params })
  },
  get (id) {
    return Vue.http.get(`${API_URL}cost-centers/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}cost-centers`, data)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}cost-centers/${id}`)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}cost-centers/${id}`, data)
  },
  checkCodeExists (code) {
    return Vue.http.post(`${API_URL}cost-centers/code/`, { code })
  }
}



// WEBPACK FOOTER //
// ./src/services/cost-center.js